module.exports = __webpack_public_path__ + "img/player2.898498a6.svg";